module.exports = __webpack_public_path__ + "static/img/login-leftBackImg.819c81b0.svg";